<!-- Notifications toggle -->
<button mat-icon-button (click)="openPanel()" [matTooltip]="'À venir'" #notificationsOrigin>
    <ng-container *ngIf="unreadCount > 0">
        <span class="absolute top-0 left-0 right-0 flex items-center justify-center h-3">
            <span
                class="flex items-center justify-center shrink-0 min-w-4 h-4 px-1 ml-4 mt-2.5 rounded-full bg-warn-600 text-indigo-50 text-xs font-medium">
                {{unreadCount}}
            </span>
        </span>
    </ng-container>
    <mat-icon [svgIcon]="'heroicons_outline:bell'"></mat-icon>
</button>

<!-- Notifications panel -->
<ng-template #notificationsPanel>

    <div
        class="fixed inset-0 flex flex-col overflow-hidden shadow-lg sm:static sm:inset-auto sm:min-w-90 sm:w-90 sm:rounded-2xl">

        <!-- Header -->
        <div class="flex mt-2 items-center py-4 pl-6 pr-4 shrink-0 bg-primary-700 text-on-primary">
            <div class="mr-3 -ml-1 sm:hidden">
                <button mat-icon-button (click)="closePanel()">
                    <mat-icon class="text-current icon-size-5" [svgIcon]="'heroicons_solid:x-circle'"></mat-icon>
                </button>
            </div>
            <div class="text-lg font-medium leading-10">Notifications</div>
            <div class="ml-auto">
                <button mat-icon-button [matTooltip]="'Tout marquer comme lu'" [disabled]="unreadCount === 0"
                    (click)="markAllAsRead()">
                    <mat-icon class="text-current icon-size-5" [svgIcon]="'heroicons_solid:mail-open'"></mat-icon>
                </button>
            </div>
        </div>

        <!-- Content -->
        <div class="relative flex flex-col flex-auto overflow-y-auto divide-y sm:max-h-120 bg-card"
            (scroll)="onScroll($event)">

            <div
                class="flex items-center px-6 py-4 space-x-3 bg-white dark:bg-transparent sticky top-0 z-10 border-b dark:border-gray-700">

                <button class="px-4 py-1.5 rounded-full text-sm font-medium transition-colors border"
                    [ngClass]="activeCategory === 'Tout' 
                            ? 'bg-accent-600 text-white border-accent-600 dark:bg-accent-500 dark:border-accent-600' 
                            : 'bg-transparent text-gray-600 border-gray-300 hover:bg-gray-50 dark:text-gray-300 dark:border-gray-600'" (click)="setCategory('Tout')">
                    Tout
                </button>

                <button class="px-4 py-1.5 rounded-full text-sm font-medium transition-colors border"
                    [ngClass]="activeCategory === 'Messages' 
                            ? 'bg-accent-600 text-white border-accent-600 dark:bg-accent-500 dark:border-accent-600' 
                            : 'bg-transparent text-gray-600 border-gray-300 hover:bg-gray-50 dark:text-gray-300 dark:border-gray-600'" (click)="setCategory('Messages')">
                    Messages
                </button>

                <button class="px-4 py-1.5 rounded-full text-sm font-medium transition-colors border"
                    [ngClass]="activeCategory === 'Activité' 
                            ? 'bg-accent-600 text-white border-accent-600 dark:bg-accent-500 dark:border-accent-600' 
                            : 'bg-transparent text-gray-600 border-gray-300 hover:bg-gray-50 dark:text-gray-300 dark:border-gray-600'" (click)="setCategory('Activité')">
                    Activité
                </button>

            </div>
            <ng-container *ngFor="let notification of notifications; trackBy: trackByFn">
                <div class="flex group hover:bg-gray-50 dark:hover:bg-black dark:hover:bg-opacity-5"
                    [ngClass]="{'unread': !notification.read}">

                    <!-- Notification with a link -->
                    <ng-container *ngIf="notification.link">
                        <ng-container *ngIf="!notification.useRouter">
                            <a class="flex flex-auto py-5 pl-6 cursor-pointer" [href]="notification.link"
                                (click)="toggleRead(notification)">
                                <ng-container *ngTemplateOutlet="notificationContent"></ng-container>
                            </a>
                        </ng-container>
                        <ng-container *ngIf="notification.useRouter">
                            <a class="flex flex-auto py-5 pl-6 cursor-pointer" [routerLink]="notification.link"
                                (click)="toggleRead(notification)">
                                <ng-container *ngTemplateOutlet="notificationContent"></ng-container>
                            </a>
                        </ng-container>
                    </ng-container>

                    <ng-container *ngIf="!notification.link">
                        <div class="flex flex-auto py-5 pl-6 cursor-pointer" (click)="toggleRead(notification)">
                            <ng-container *ngTemplateOutlet="notificationContent"></ng-container>
                        </div>
                    </ng-container>

                    <!-- Actions -->
                    <div class="relative flex flex-col my-5 ml-2 mr-6">
                        <!-- Indicator -->
                        <button class="w-6 h-6 min-h-6" mat-icon-button (click)="toggleRead(notification)">
                            <span class="w-2 h-2 rounded-full" [ngClass]="{'bg-gray-400 dark:bg-gray-500 sm:opacity-0 sm:group-hover:opacity-100': notification.read,
                                            'bg-primary': !notification.read}"></span>
                        </button>
                        <!-- Remove -->
                        <!-- <button class="w-6 h-6 min-h-6 sm:opacity-0 sm:group-hover:opacity-100" mat-icon-button
                            (click)="delete(notification)" [matTooltip]="'Remove'">
                            <mat-icon class="icon-size-4" [svgIcon]="'heroicons_solid:x'"></mat-icon>
                        </button> -->
                    </div>

                </div>

                <!-- Notification content template -->
                <ng-template #notificationContent>
                    <!-- Icon -->
                    <ng-container *ngIf="notification.icon && !notification.image">
                        <div class="flex items-center justify-center w-8 h-8 mr-4 rounded-full shrink-0"
                            [ngClass]="notification.bgColorClass || 'bg-gray-100 dark:bg-gray-700'">

                            <mat-icon class="icon-size-5" [ngClass]="notification.iconColorClass || ''"
                                [svgIcon]="notification.icon">
                            </mat-icon>
                        </div>
                    </ng-container>
                    <!-- Image -->
                    <ng-container *ngIf="notification.image">
                        <img class="object-cover object-center w-8 h-8 mr-4 overflow-hidden rounded-full shrink-0"
                            [src]="notification.image" [alt]="'Notification image'">
                    </ng-container>
                    <!-- Title, description & time -->
                    <div class="flex flex-col flex-auto">
                        <ng-container *ngIf="notification.title">
                            <div class="font-semibold" [innerHTML]="notification.title"></div>
                        </ng-container>
                        <ng-container *ngIf="notification.description">
                            <div class="mt-1" [innerHTML]="notification.description"></div>
                        </ng-container>
                        <div class="mt-2 text-sm leading-none text-secondary flex items-center">
                            <span [matTooltip]="getAbsoluteTime(notification.time)">{{ getRelativeTime(notification.time) }}</span>
                        </div>
                    </div>
                </ng-template>
            </ng-container>

            <div *ngIf="notifications && notifications.length > 0 && notifications.length < totalCount"
                class="py-4 flex justify-center bg-gray-50 dark:bg-transparent">
                <button mat-button class="bg-primary text-on-primary" (click)="loadMore()" [disabled]="isLoading">
                    {{ isLoading ? 'Chargement...' : 'Voir plus (' + notifications.length + '/' + totalCount + ')' }}
                </button>
            </div>

            <div *ngIf="notifications && notifications.length === totalCount && totalCount > 0"
                class="py-4 text-center text-sm text-secondary">
                Vous avez atteint la fin.
            </div>

            <!-- No notifications -->
            <ng-container *ngIf="!notifications || !notifications.length">
                <div class="flex flex-col items-center justify-center flex-auto px-8 py-12 sm:justify-start">
                    <div class="flex items-center justify-center rounded-full flex-0 w-14 h-14 bg-primary-100">
                        <mat-icon class="text-primary-500-700" [svgIcon]="'heroicons_outline:bell'"></mat-icon>
                    </div>
                    <div class="mt-5 text-2xl font-semibold tracking-tight">Aucune notifications</div>
                    <div class="w-full mt-1 text-center max-w-60 text-md text-secondary">
                        Lorsque vous aurez des notifications,
                        elles apparaîtront ici.</div>
                </div>
            </ng-container>

        </div>

    </div>

</ng-template>